import WEDirectory from "../components/WEDirectory";

function Audits(props: any) {
	return (
		<>
			<div
				className="generic-container"
				style={{ overflow: "auto", height: "100vh" }}
			>
				<WEDirectory tabKey={"audits"} />
			</div>
		</>
	);
}

export default Audits;
